/** Staff override. The portal never uses this. */
export type CancellationOverrideChoice =
  | 'keep_policy'
  | 'full_refund'
  | 'partial_refund'
  | 'waive_fee'
  | 'restore_clip';

export function canOverrideCancellation(input: {
  isAdmin: boolean;
  canAmendInvoices: boolean;
  canUpdateInvoices: boolean;
  canTakePayments: boolean;
}): boolean {
  return (
    input.isAdmin ||
    input.canAmendInvoices ||
    (input.canUpdateInvoices && input.canTakePayments)
  );
}

export function overrideNeedsReason(choice: CancellationOverrideChoice): boolean {
  return choice !== 'keep_policy';
}
